<template>
  <div class="filters" :style="{ '--source-color': `var(--${color}-main)` }">
    <div v-if="hasSource" class="filters__source">
      <FilterSource></FilterSource>
    </div>
    <!-- Main source -->
    <button
      class="filters__button"
      @click="toggleFilterMenu()"
      v-if="(hasDataType || hasGeoAreas) && $tvaMq !== 'tablet'"
    >
      <p class="filters__button--label">Filtri</p>
      <div :key="icon" class="filters__button--icon">
        <svgicon :name="icon" height="2.625rem" width="2.625rem" />
      </div>
    </button>
    <!-- Others -->
    <Transition name="slide-in">
      <div
        class="filters__wrapper"
        v-if="filterMenu && (hasDataType || hasGeoAreas)"
      >
        <FilterDataType
          v-if="hasDataType"
          direction="row"
          class="filters__wrapper--type"
        ></FilterDataType>

        <FilterGeoArea
          v-if="hasGeoAreas"
          direction="column"
          class="filters__wrapper--area"
        ></FilterGeoArea>
      </div>
    </Transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import FilterGeoArea from "../../filters/FilterGeoArea";
import FilterDataType from "../../filters/FilterDataType";
import FilterSource from "../../filters/FilterSource.vue";
export default {
  name: "FiltersMobile",
  components: {
    FilterGeoArea,
    FilterDataType,
    FilterSource,
  },
  data() {
    return { filterMenu: false };
  },
  computed: {
    icon() {
      if (this.filterMenu) {
        return "arrow-up";
      } else {
        return "arrow-down";
      }
    },
    sources() {
      return this.sourceConfig.sources;
    },
    hasSource() {
      return this.sourceConfig && this.sourceConfig.sources ? true : false;
    },
    dataTypes() {
      return this.sourceConfig.dataTypes;
    },
    hasDataType() {
      return this.sourceConfig && this.sourceConfig.dataTypes ? true : false;
    },
    hasGeoAreas() {
      return this.sourceConfig && this.sourceConfig.geoAreas ? true : false;
    },
    color() {
      return this._color();
    },

    ...mapGetters({
      source: "ui/source",
      sourceConfig: "ui/currentSourceConfig",
      geoArea: "ui/geoArea",
      _color: "ui/sourceColor",
    }),
  },
  mounted() {
    this.$nextTick(() => {
      this.initFiltersStatus();
    });
  },

  methods: {
    toggleFilterMenu() {
      this.filterMenu = !this.filterMenu;
    },
    initFiltersStatus() {
      // set new status according to current source
      this.initDataTypeStatus();
      this.initSourceStatus();
      this.initGeoAreaStatus();

      // console.log('COLOR',this.sourceConfig.colorName);

      this.calcData();
    },

    initGeoAreaStatus() {
      if (this.hasGeoAreas) {
        const current = this.geoArea;

        if (current !== null) {
          // if old source and new source share geoArea, keep it
          this.setGeoArea(current);
        } else {
          // set the first one selected
          this.setGeoArea("World");
        }
      } else {
        this.setGeoArea("World");
      }
    },
    initDataTypeStatus() {
      if (this.hasDataType) {
        const current = this.dataType;

        if (current !== null && this.dataTypes.indexOf(current) > -1) {
          // if old source and new source share dataType, keep it
          this.setDataType(current);
        } else {
          // set the first one selected
          this.setDataType(this.dataTypes[0]);
        }
      } else {
        this.setDataType(null);
      }
    },
    initSourceStatus() {
      if (this.hasSource) {
        this.setSource(this.sources[0].key);
      } else {
        this.setSource(null);
      }
    },

    ...mapActions({
      setSource: "ui/setSource",
      setDataType: "ui/setDataType",
      setGeoArea: "ui/setGeoArea",
      calcData: "data/calcData",
    }),
  },
  watch: {
    $route() {
      // when route change reset all filters then set new ones if needed
      this.initFiltersStatus();
    },
    $tvaMq() {
      if (this.$tvaMq === "tablet") {
        this.filterMenu = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.filters {
  width: 100%;
  height: fit-content;
  transition: all 0.4s ease;
  background-color: var(--source-color);

  &__button {
    width: 100%;
    display: flex;
    height: toRem(48);
    align-items: center;
    justify-content: space-between;
    padding-left: toRem(17);
    border-bottom: $white-border;
    position: relative;

    &--icon {
      position: absolute;
      height: 100%;
      top: 0;
      right: 0;
      padding-right: toRem(7);
      display: flex;
      align-items: center;
    }

    &--label {
      @include dida-L;
      color: $ui-white;
    }
  }

  &__wrapper {
    height: fit-content;
    display: flex;
    flex-direction: column;
    padding: toRem(12) 0 0 toRem(17);
    overflow: hidden;
    @include filter-dropdown;

    &--type {
      margin-bottom: toRem(18);
    }
  }
}

.tablet {
  .filters {
    &__wrapper {
      padding: toRem(21) 0 toRem(28) toRem(40);

      &--type {
        margin-bottom: toRem(23);
      }
    }
  }
}
</style>
